import errorMessages from './validatorsMessages';

function errorMessage(data) {
  const msg = errorMessages[data.type];
  if (typeof msg === 'undefined') return '';
  if (data.type === 'minValue' || data.type === 'minValueDeposit' || data.type === 'greaterThan') {
    const value = data.min < 1 ? data.min.toFixed(2) : data.min;
    return msg.replace(/%v/g, value);
  }
  if (data.type === 'maxValueDeposit') {
    return msg.replace(/%v/g, data.max.toLocaleString('en-US'));
  }
  if (data.type === 'minLength' || data.type === 'minLengthDigit')
    return msg.replace(/%v/g, data.min);
  if (data.type === 'maxLength' || data.type === 'maxLengthDigit')
    return msg.replace(/%v/g, data.max);
  if (data.type === 'between')
    return msg.replace(/%v1/g, data.min.toFixed(2)).replace(/%v2/g, data.max.toFixed(2));
  if (data.type === 'exactLength') return msg.replace(/%v/g, data.target);
  return msg;
}

export default function getValidationMessage(field) {
  if (field.$invalid) {
    if (field.required && field.required.$invalid) {
      return errorMessages.required;
    }
    if (field.errorMessage) {
      return field.errorMessage;
    }
    // @vuelidate/core v2 no longer exposes a flat $params map + per-rule
    // booleans on the field result (that was vuelidate 0.x); failed rules
    // are now listed in $silentErrors, each carrying its own $params.
    const firstError = (field.$silentErrors || []).find((err) => err.$params && err.$params.type);
    return firstError ? errorMessage(firstError.$params) : '';
  }
  return '';
}
